import React, {Component} from 'react'
import {connect} from 'react-redux'
import PropTypes from "prop-types";

import {updateValues} from '../../../routers/data'
import Ida from '../../../images/svg/ida.js'
import IdaVuelta from '../../../images/svg/idayvuelta.js'

const list = [{icon: <IdaVuelta />, desc: 'roundtrip'},
               {icon: <Ida />, desc: 'onlygoing'}]

const Item = ({index, nameclass, select, icon, desc, onClick}) =>{
  const classname = (select)?`${nameclass}-select`:''

  return (
    <li className={classname} onClick={onClick} value={index}>
      <div className={`svg-${nameclass}`}>
        {icon}
      </div>
      {desc}
    </li>
  )
}

class travel extends Component{
  static contextTypes = {
    router: PropTypes.object
  }

  render(){
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].fastbooking.travels

    const {travel, updateValues, color} = this.props
    const nameclass = (color === undefined)? 'travel-blue': 'travel-' + color
    return(
      <div className={nameclass}>
        <ul>
          {list.map((item, index) => <Item key={index} index={index} select={travel === index} {...item} desc={langPlace[item.desc]} nameclass={nameclass} color={color}
                                       onClick={() => updateValues({'travel': index, bCouple: false, returndate: undefined})}/>)}
        </ul>
      </div>
    )
  }
}

export default connect(
	(state) => ({settings: state.settings, travel: state.data.values.travel}),
  {updateValues}
)(travel)



// WEBPACK FOOTER //
// ./src/shared/routes/components/fastbooking/travel.js